import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF,
} from "./actionTypes"

import {
    getRavenAuthorizationResponseCodeDefListSuccess,
    ravenAuthorizationResponseCodeDefApiError
} from "./actions"

//Include Both Helper File with needed methods
import {
    GetAllRavenAuthorizationResponseCodeDef,
} from "../../helpers/backend_helper/backend_helper"

function* onGetRavenAuthorizationResponseCodeDefList() {
  try {
    const response = yield call(GetAllRavenAuthorizationResponseCodeDef)
    yield put(getRavenAuthorizationResponseCodeDefListSuccess(response))
  } catch (error) {
    yield put(ravenAuthorizationResponseCodeDefApiError(error))
  }
}

function* ravenAuthorizationResponseCodeDefSaga() {
    yield takeEvery(GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF,onGetRavenAuthorizationResponseCodeDefList)
}

export default ravenAuthorizationResponseCodeDefSaga